module.exports = __webpack_public_path__ + "media/assets/icon-c403fee1.png";